import * as types from './mutation-types'

export const loadReasonTypes = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('movement/types').then((response) => {
            commit(types.LOAD_REASON_TYPES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadReasons = ({commit}, type="") => {
    return new Promise((resolve, reject) => {
        const {typeId, typeTitle} = type?.title ? { typeId: '', typeTitle: type?.title } : { typeId: type, typeTitle: '' }
        window.axios.get(`reasons?type=${typeId}&title=${typeTitle}`).then((response) => {
            commit(types.LOAD_REASONS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createReason = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('store/stock/movement/reason', data).then((response) => {
            resolve(response)
            commit(types.ADD_REASON, response.data.reason)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateReason = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/stock/movement/reason', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteReason = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/stock/movement/reason').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

